import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-use';
import { TrackEvent, TAnyParams } from '@alycecom/services';

import { getGiftHashId, getIsCode } from '../modules/RecipientModule/store/data/data.selectors';

type TUseTrackRecipientHandler = (name: string, payload?: TAnyParams, options?: TAnyParams) => void;

export default (): TUseTrackRecipientHandler => {
  const { trackEvent } = TrackEvent.useTrackEvent();
  const state = useLocation();
  const hashId = useSelector(getGiftHashId);
  const isCode = useSelector(getIsCode);

  const commonPayload = useMemo(
    () => ({
      giftHash: !isCode ? hashId : '',
      codeHash: isCode ? hashId : '',
    }),
    [hashId, isCode],
  );

  const commonOptions = useMemo(
    () => ({
      ref: state.pathname,
    }),
    [state],
  );

  return useCallback(
    (eventName, payload = {}, options = {}) => {
      trackEvent(eventName, { ...commonPayload, ...payload }, { ...commonOptions, ...options });
    },
    [trackEvent, commonPayload, commonOptions],
  );
};
